import { PATH_CONSTANT } from 'constant/PathConstant';
import { TableDefinitionKind } from '../types';

export const TABLE_DEFINITION_TAB_BY_KIND: Record<TableDefinitionKind, string> = {
  'associated-attribute': 'ASSOCIATED_ATTRIBUTE',
  'associated-subject': 'ASSOCIATED_SUBJECT',
};

export function isTableDefinitionKind(value?: string): value is TableDefinitionKind {
  return value === 'associated-attribute' || value === 'associated-subject';
}

export function buildTableDefinitionV2ListPath(subjectId?: string | number, kind?: TableDefinitionKind) {
  const searchParams = new URLSearchParams();
  if (subjectId) searchParams.set('sid', String(subjectId));
  if (kind) searchParams.set('tab', TABLE_DEFINITION_TAB_BY_KIND[kind]);
  const search = searchParams.toString();
  return `${PATH_CONSTANT.SYSTEM.KMS.DATA_BUILDER.TABLE_DEFINITION_V2.LIST}${search ? `?${search}` : ''}`;
}

export function buildTableDefinitionV2CreatePath(subjectId: string | number, kind: TableDefinitionKind) {
  return PATH_CONSTANT.SYSTEM.KMS.DATA_BUILDER.TABLE_DEFINITION_V2.CREATE.replace(
    ':subjectId',
    String(subjectId)
  ).replace(':definitionKind', kind);
}

export function buildTableDefinitionV2EditPath(
  subjectId: string | number,
  kind: TableDefinitionKind,
  tableDefinitionId: string | number,
  section?: 'parameters' | 'validation'
) {
  const path = PATH_CONSTANT.SYSTEM.KMS.DATA_BUILDER.TABLE_DEFINITION_V2.EDIT.replace(
    ':subjectId',
    String(subjectId)
  )
    .replace(':definitionKind', kind)
    .replace(':tableDefinitionId', String(tableDefinitionId));
  return section ? `${path}?section=${section}` : path;
}

